<template>
  <div class="pa-10">
    <title-page icon="mdi-file-chart-outline">
      {{ $t('reports.reports') }}
    </title-page>


    <v-breadcrumbs
        :items="[{text: $t('reports.reports')}]"
        divider=">"
    ></v-breadcrumbs>

    <v-row>
      <v-col md="4" v-for="(report, i) in reports" :key="'report-' + i">
        <v-card :to="report.to">
          <v-card-title>
            {{ report.label }}
          </v-card-title>
          <v-card-text class="text-center">
            <v-icon size="80">
              {{ report.icon ? report.icon : 'mdi-poll' }}
            </v-icon>

          </v-card-text>
          <v-divider></v-divider>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },

  computed: {
    reports() {
      // {label: 'Clients', disabled: true},
      // {label: 'Bornes', disabled: true},
      // {label: 'Type de bornes', disabled: true},
      // {label: 'Cartes bancaires expirées', disabled: true},
      // {label: 'Transactions financières', disabled: true},

      let reports = []

      if (this.currentUser.permissions.includes('REPORT_USAGE')) {
        reports.push({
          label: this.$t('reports.usages.usages'),
          to: {name: 'reports.usages'},
          icon: 'mdi-file-chart-outline'
        })
      }

      if (this.currentUser.permissions.includes('REPORT_OFFLINE')) {
        reports.push({
          label: this.$t('reports.offline.offline'),
          to: {name: 'reports.offline'},
          icon: 'mdi-wifi-strength-off-outline'
        })
      }

      if (this.currentUser.isZE && this.currentUser.permissions.includes('OPERATOR_WRITE')) {
        reports.push({
          label: this.$t('reports.financial.dashboard'),
          to: {name: 'reports.financial'},
          icon: 'mdi-chart-pie'
        })

        reports.push({
          label: this.$t('billing-control.workspace'),
          to: {name: 'reports.billing-control'},
          icon: 'mdi-finance'
        })

        reports.push({
          label: this.$t('revenue-cutoff.title'),
          to: {name: 'reports.revenue-cutoff'},
          icon: 'mdi-calendar-check'
        })
      }

      if (this.currentUser.isZE && this.currentUser.permissions.includes('OPERATOR_WRITE')) {
        reports.push({
          label: this.$t('recharge-service.recharge-service'),
          to: {name: 'reports.energy-provider'},
          icon: 'mdi-lightning-bolt'
        })

        reports.push({
          label: this.$tc('proforma-invoice.proforma-invoice', 2),
          to: {name: 'proforma-invoices'},
          icon: 'ico-invoice'
        })
      }
      if( this.currentUser.permissions.includes('ORGANIZATION_WRITE')) {
        reports.push({
          label: this.$tc('invoice.invoice', 2),
          to: {name: 'invoices'},
          icon: 'ico-invoice'
        })
      }

      if (this.currentUser.isZE && this.currentUser.permissions.includes('OPERATOR_WRITE')) {
        reports.push({
          label: this.$t('proforma-invoice.conversion-task.history-menu'),
          to: {name: 'proforma-invoice-conversion-task.list'},
          icon: 'mdi-history'
        })
      }

      if (this.currentUser.showBillingRequests && this.currentUser.permissions.includes('ORGANIZATION_WRITE')) {
        reports.push({
          label: this.$tc('billing-request.billing-request', 2),
          to: {name: 'billing-requests'},
          icon: 'mdi-invoice-text-multiple-outline'
        })
      }

      if (this.currentUser.isZE && this.currentUser.permissions.includes('OPERATOR_WRITE')) {
        reports.push({
          label: this.$tc('anomaly.subscription-anomalies', 2),
          to: {name: 'anomaly.subscription'},
          icon: 'mdi-file-document-alert-outline'
        })

        reports.push({
          label: this.$tc('reports.meter-device-statements', 2),
          to: {name: 'reports.meter-device-statements'},
          icon: 'mdi-format-list-numbered'
        })

        reports.push({
          label: this.$tc('reports.exports', 2),
          to: {name: 'reports.exports'},
          icon: 'mdi-file-delimited-outline'
        })
      }

      if (this.currentUser.permissions.includes('REPORT_USAGE')) {
        reports.push({
          label: this.$t('exports.title'),
          to: {name: 'exports.list'},
          icon: 'mdi-database-export-outline'
        })
      }

      // La logistique de l'onboarding : les commandes en attente, en files de travail (badges à envoyer compris).
      if (this.currentUser.permissions.includes('ONBOARDING_MODULE_MANAGE')) {
        reports.push({
          label: this.$t('onboarding.queue.title'),
          to: {name: 'onboarding.commissionings'},
          icon: 'mdi-inbox-full-outline'
        })
      }

      if (this.currentUser.isZE && this.currentUser.permissions.includes('OPERATOR_WRITE')) {
        reports.push({
          label: this.$t('mail-event.mail-events'),
          to: {name: 'reports.mail-events'},
          icon: 'mdi-email-multiple'
        })
      }


      return reports
    }
  }

}
</script>

<style lang="scss">

</style>
